import type { ReminderAttemptStatus } from '../enums/ReminderAttemptStatus'

export class ReminderEntity {
  displayDate?: string
  status?: ReminderAttemptStatus
  statusLogs?: Array<ReminderStatusLogEntity> | null
}
export class ReminderStatusLogEntity {
  date?: string
  status?: ReminderAttemptStatus
}
